export default setImage => {
    const el = window.document.createElement("input");
    el.setAttribute("type", "file");
    el.setAttribute("accept", "image/*");
    el.addEventListener('change', () => {
        const file = el.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => setImage(reader.result);
        reader.onerror = error => console.error(error);
    });
    el.click();
    return false;
};


// WEBPACK FOOTER //
// ./src/modules/SelectImage.js